import { type PaymentMethodEnum } from '~types'

export function isNumeric(value: string | number): boolean {
  return (
    typeof value === 'number' ||
    (typeof value === 'string' && !isNaN(Number(value)) && value.trim() !== '')
  )
}

export function renderCost(amount: number): string {
  if (amount < 0) {
    return `-$${Math.abs(amount / 100).toFixed(2)}`
  } else {
    return `$${(amount / 100).toFixed(2)}`
  }
}

export const formatUSD = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value)
}

type PaymentMethodInfo = [name: string, color: string]

export const methodColorMap: { [key in PaymentMethodEnum]: PaymentMethodInfo } = {
  ['BankPayment']: ['ACH / E-Check', '#22577A'],
  ['CardPayment']: ['Credit Card', '#38A3A5'],
  ['CashPayment']: ['Cash', '#57CC99'],
  ['CheckPayment']: ['Check', '#80ED99'],
  ['MoneyOrderPayment']: ['Money Order', '#FFF4CC'],
  ['OtherPayment']: ['Other', '#C7F9CC'],
}

export const otherGraphColors = ['#cbebf8', '#86d0ee', '#1fa7e0', '#1a8dbd', '#115a79', '#072634']
